/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateSSOImageLangViewModel } from "../types/CreateSSOImageLangViewModel.ts";
import { eViewPortSchema } from "./eViewPortSchema.ts";

export const createSSOImageLangViewModelSchema = z.object({
  cultureInfo: z.string().min(1),
  content: z.string().min(1),
  viewPort: z
    .lazy(() => eViewPortSchema)
    .describe("1 = Desktop | 2 = Mobile | "),
}) as unknown as ToZod<CreateSSOImageLangViewModel>;
